import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { BaseSiteService, CmsService, OccEndpointsService, RoutingService } from "@spartacus/core";
import { Subscription } from "rxjs";
import { take } from "rxjs/operators";
import { ResourcesService } from "../../resources.service";
[]

@Component({
    selector: 'app-reimbursement-support',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './reimbursement-support.component.html',
    styleUrls: ['./reimbursement-support.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ReimbursementSupportComponent implements OnInit {
  contactOnlineForm: FormGroup;
  submitServiceDetails$: Subscription;
  formDetails$: Subscription;
  cmsResponseBodyDesc: any;
  cmsResponseEmailFaxTitle: any;
  cmsResponseCallSupportContent: any;
  reimbursePdfDetailsObj: any;
  fluInquiryPdfDetailsObj: any;
  baseSiteId: any;
  baseUrl: string;
  detailsSuccessfullySubmitted: boolean = false;
  submitted: boolean = false;

  constructor(
    private fb: FormBuilder,
    private readonly cd: ChangeDetectorRef,
    private readonly route: RoutingService,
    private readonly cmsService: CmsService,
    private readonly baseSiteService: BaseSiteService,
    private readonly resourceService: ResourcesService,
    private readonly occEndPoint: OccEndpointsService
  ) {}

  ngOnInit(): void {
    this.baseUrl = this.occEndPoint.getBaseUrl({
      baseUrl: true,
      prefix: false,
      baseSite: false,
    });
    this.baseSiteService
      .getActive()
      .pipe(take(1))
      .subscribe((res) => (this.baseSiteId = res));
    this.contactOnlineForm = this.fb.group({
      locationName: new FormControl('', Validators.required),
      contactName: new FormControl('', [Validators.required, Validators.pattern('[-_a-zA-Z ]*')]),
      title: new FormControl('', [Validators.pattern('[-_a-zA-Z0-9 ]*')]),
      streetAddress: new FormControl('', Validators.required),
      cityStateZipcode: new FormControl('', Validators.required),
      telephone: new FormControl('', [
        Validators.required,
        Validators.minLength(12),
      ]),
      fax: new FormControl('', [Validators.minLength(12)]),
      emailAddress: new FormControl('', [
        Validators.required,
        Validators.email,
      ]),
      question: new FormControl('', Validators.required),
    });
    this.getCMSData();
    this.getDetails();
  }

  getCMSData() {
    this.cmsService
      .getComponentData('reimServiceDescriptionComponent')
      .pipe(take(1))
      .subscribe((res) => (this.cmsResponseBodyDesc = res['content']));
    this.cmsService
      .getComponentData('reimServiceCallSupportComponent')
      .pipe(take(1))
      .subscribe(
        (res) =>
          (this.cmsResponseCallSupportContent = res['content'].replaceAll(
            `<img src="`,
            `<img src="${this.baseUrl}`
          ))
      );
    this.cmsService
      .getComponentData('sanofiMultiMediaComp')
      .pipe(take(1))
      .subscribe((res) => (this.cmsResponseEmailFaxTitle = res['description']));
    this.cmsService
      .getComponentData('ReimbursemenSupportInquiryPDFComponent')
      .pipe(take(1))
      .subscribe((res) => (this.reimbursePdfDetailsObj = res));
    this.cmsService
      .getComponentData('InfluenzaSupportInquiryPDFComponent')
      .pipe(take(1))
      .subscribe((res) => (this.fluInquiryPdfDetailsObj = res));
  }

  downloadPdf(url) {
    window.open(this.baseUrl + url);
  }

  getDetails() {
    this.resourceService.getServiceDetails();
    this.formDetails$ = this.resourceService.serviceDetails.subscribe((res) => {
      this.contactOnlineForm.controls.locationName.patchValue(
        res?.locationName
      );
      this.contactOnlineForm.controls.contactName.patchValue(res?.contactName);
      this.contactOnlineForm.controls.title.patchValue(res?.title);
      this.contactOnlineForm.controls.streetAddress.patchValue(
        res?.streetAddress
      );
      this.contactOnlineForm.controls.cityStateZipcode.patchValue(
        res?.cityStateZipcode
      );
      this.contactOnlineForm.controls.telephone.patchValue(res?.telephone);
      this.contactOnlineForm.controls.fax.patchValue(res?.fax);
      this.contactOnlineForm.controls.emailAddress.patchValue(
        res?.emailAddress
      );
      this.contactOnlineForm.controls.question.patchValue(res?.question);
    });
  }

  formatPhoneNumber(event: any): void {
    const input = this.contactOnlineForm.controls.telephone.value;
    let value = input.replace(/\D/g, ''); // Remove non-digit characters
    // Ensure the input is limited to 10 digits

    // Format the phone number as "111-111-1111"
    if (event.keyCode === 8) {
      return; // Skip the code execution for Backspace
    }
    if (value.length >= 3 && value.length <= 6) {
      value = value.slice(0, 3) + '-' + value.slice(3);
      this.contactOnlineForm.controls.telephone.patchValue(value);
    } else if (value.length >= 7 && value.length <= 10) {
      value =
        value.slice(0, 3) + '-' + value.slice(3, 6) + '-' + value.slice(6);
      this.contactOnlineForm.controls.telephone.patchValue(value);
    }
  }

  formatFaxNumber(event: any): void {
    const input = this.contactOnlineForm.controls.fax.value;
    let value = input.replace(/\D/g, ''); // Remove non-digit characters
    // Ensure the input is limited to 10 digits

    // Format the phone number as "111-111-1111"
    if (event.keyCode === 8) {
      return; // Skip the code execution for Backspace
    }
    if (value.length >= 3 && value.length <= 6) {
      value = value.slice(0, 3) + '-' + value.slice(3);
      this.contactOnlineForm.controls.fax.patchValue(value);
    } else if (value.length >= 7 && value.length <= 10) {
      value =
        value.slice(0, 3) + '-' + value.slice(3, 6) + '-' + value.slice(6);
      this.contactOnlineForm.controls.fax.patchValue(value);
    }
  }

  onFormSubmit() {
    this.submitted = true;
    let obj = {
      locationName: this.contactOnlineForm.controls.locationName.value,
      contactName: this.contactOnlineForm.controls.contactName.value,
      title: this.contactOnlineForm.controls.title.value,
      streetAddress: this.contactOnlineForm.controls.streetAddress.value,
      cityStateZipcode: this.contactOnlineForm.controls.cityStateZipcode.value,
      telephone: this.contactOnlineForm.controls.telephone.value,
      fax: this.contactOnlineForm.controls.fax.value,
      emailAddress: this.contactOnlineForm.controls.emailAddress.value,
      question: this.contactOnlineForm.controls.question.value,
    };

    if (this.contactOnlineForm.valid) {
      this.submitServiceDetails$ = this.resourceService
        .submitServiceDetails(obj)
        .subscribe((res) => {
          if (res) {
            if (res?.status.toLowerCase() === 'success') {
              this.detailsSuccessfullySubmitted = true;
              this.cd.detectChanges();
            }
          }
        });
    }
  }

  navigateToResourcePage() {
    this.route.goByUrl('/reimbursementBillingAndCodingPage');
  }

  ngOnDestroy() {
    this.formDetails$.unsubscribe();
    if(this.submitted){
      this.submitServiceDetails$.unsubscribe();
    }
  }
}
